export default function arabicTransform(input) {
  return input
    .replace(/a/gi, "آ")
    .replace(/b/gi, "أ")
    .replace(/c/gi, "ؤ")
    .replace(/d/gi, "إ")
    .replace(/e/gi, "ئ")
    .replace(/f/gi, "ئ")
    .replace(/g/gi, "ا")
    .replace(/h/gi, "ب")
    .replace(/i/gi, "ة")
    .replace(/j/gi, "ت")
    .replace(/k/gi, "ث")
    .replace(/l/gi, "ج")
    .replace(/m/gi, "خ")
    .replace(/n/gi, "د")
    .replace(/o/gi, "ذ")
    .replace(/p/gi, "ر")
    .replace(/q/gi, "ز")
    .replace(/r/gi, "س")
    .replace(/s/gi, "آ")
    .replace(/t/gi, "ص")
    .replace(/u/gi, "ض")
    .replace(/v/gi, "ط")
    .replace(/x/gi, "ع")
    .replace(/w/gi, "ظ")
    .replace(/y/gi, "غ")
    .replace(/z/gi, "ב")
    .replace(/ /gi, "ㅤ");
}
